// extracted by mini-css-extract-plugin
module.exports = {"profileAvatarWrapper":"avatar_profileAvatarWrapper__2xyAC","avatarBlock":"avatar_avatarBlock__3G9Ln","name":"avatar_name__1qP89"};